import { ShieldCheckIcon } from '@heroicons/react/24/solid';

import MarkDownRender from '~/components/Markdown/MarkDownRender';
import Text from '~/components/Text';
import renderTime from '~/utils/renderTime';

interface Props {
  imageUrl: string;
  name: string;
  content: string;
  time: string;
  isModerator: boolean;
}

const CommentDisplay = ({ imageUrl, name, content, time, isModerator }: Props) => {
  const processedContent = content?.replace(/\n/g, '&nbsp;  \n') || '';
  return (
    <div className="flex">
      <img className="h-7 w-7 rounded-full" src={imageUrl} alt="The user involved in the comment" />
      <div className="ml-2 sm:ml-3">
        <div className="">
          <div className="flex items-center">
            {isModerator && (
              <div>
                <ShieldCheckIcon className="mr-1 h-4 w-4 text-wt-primary" />
              </div>
            )}
            <Text as="p" size="sm" theme="content" weight="semibold">
              {name} <span className="font-light opacity-70"> &#x2022; {renderTime(time)}</span>
            </Text>
          </div>
          <Text as="div" size="sm" theme="content" weight="regular">
            <MarkDownRender>{processedContent}</MarkDownRender>
          </Text>
        </div>
      </div>
    </div>
  );
};

export default CommentDisplay;
